import React from 'react';
import { usePermitRequestContext } from '../../../../../contexts/PermitRequestContext';
import RadioBtnsContainer from '../../../../../components/form/radios/RadioBtnsContainer';
import RadioOutlineBtn from '../../../../../components/form/radios/RadioOutlineBtn';
import InputGroup from '../../../../../components/form/InputGroup';
import addRequestPageLang from '../../../../../data/lang/add-request-page.lang';
import { useTags } from '../../../../../hooks/useTags';

const HasBusinessFiles = () => {
    const { Formik, handleChangeFile } = usePermitRequestContext();
    const { errors, values, touched, handleBlur, setFieldValue } = Formik;

    const errorsExstraFiles = errors.extraFiles ? errors.extraFiles : {};
    const touchedExstraFiles = touched.extraFiles ? touched.extraFiles : {};


    const generateTag = useTags();

    const sectionTitle = generateTag(addRequestPageLang, 'form.files-section.has-business-title');
    const yesLabel = generateTag(addRequestPageLang, 'form.files-section.yesLabel');
    const noLabel = generateTag(addRequestPageLang, 'form.files-section.noLabel');
    const businessTaxBillLabel = generateTag(addRequestPageLang, 'form.files-section.business-tax-bill-label');

    return (
        <div className='row'>
            <div className='col-12'>
                <RadioBtnsContainer label={sectionTitle}>

                    <RadioOutlineBtn
                        isChecked={values.extraFiles.hasBusiness === 0}
                        label={noLabel}
                        value={0}
                        onClick={handleClick}
                        id="hasBusinessNo"
                        name='extraFiles.hasBusiness'
                    />

                    <RadioOutlineBtn
                        isChecked={values.extraFiles.hasBusiness === 1}
                        label={yesLabel}
                        value={1}
                        onClick={handleClick}
                        id="hasBusinessYes"
                        name='extraFiles.hasBusiness'
                    />
                </RadioBtnsContainer>
            </div>

            {values.extraFiles.hasBusiness === 1 ? (
                <div className='col-md-6 col-lg-4'>
                    <InputGroup
                        label={businessTaxBillLabel}
                        name={'extraFiles.extraFile3'}
                        type={'file'}
                        isRequired={true}
                        handleBlur={handleBlur}
                        handleChange={(event) => {
                            handleChangeFile('extraFiles.extraFile3', 'extraFile3', event.currentTarget.files[0]);
                        }}
                        // @ts-ignore
                        errorMsg={(errorsExstraFiles.extraFile3 && touchedExstraFiles.extraFile3) ? errorsExstraFiles.extraFile3 : undefined}
                    />
                </div>
            ) : ''}
        </div>
    );

    function handleClick(e: React.MouseEvent<HTMLInputElement>) {
        setFieldValue('extraFiles.hasBusiness', Number(e.currentTarget.value));
    }
};

export default HasBusinessFiles;